// APIの纏め

// API-ID: AOD002 優待施設データ取得
export const API_SHOP_LIST = '/api/get_shop_list_jaf.php'

// API-ID: AOD003 FC対応優待施設データ取得
export const API_SHOP_LIST_FC = '/api/get_shop_list_fc.php'

// API-ID: AOE001 お気に入りデータ取得
export const API_FAVOR_LIST = '/api/get_favorite_list.php'

// API-ID: AOE002 お気に入り更新
export const API_UPDATE_FAVOR_SHOP = '/api/inupdate_favorite.php'

// API-ID: AOF004 訪問履歴取得および更新
export const API_VISIT_HISTORY_AND_UPDATE = '/api/get_houmonn_rireki.php'

// API-ID: AOI002 検索履歴取得および更新
export const API_SEARCH_HISTORY_AND_UPDATE = '/api/search_history.php'

// API-ID: AOJ001 クーポンデータ取得
export const API_COUPON_LIST = '/api/get_coupon_jaf_list.php'

// API-ID: AOK001 クーポン使用ログ登録
export const API_SET_USED_COUPON = '/api/set_used_coupon.php'

// API-ID: AOK004 クーポンクリップ更新
export const API_UPDATE_FAVOR_COUPON = '/api/inupdate_coupon_clip.php'

// API-ID: AOP002 SSOセッション確認
export const API_SESSION_CHECK = '/api/session_login.php'

// API-ID: AOD004 クーポン対象優待施設データ取得
export const API_COUPON_SHOP_LIST = '/api/get_coupon_shop_list.php'

// API-ID: AOJ002 優待施設クーポンデータ取得
export const API_SHOP_COUPON_LIST = '/api/get_shop_coupon_list.php'

// API-ID:
export const API_TAB_SHOP_LIST = '/api/get_tab_shop_list.php'

// 新規終了優待施設
export const API_NEW_OLD_SHOP_LIST = '/api/get_new_old_shop_list.php'

// ブランド別優待施設
export const API_BRAND_SHOP_LIST = '/api/get_brand_shop_list.php'

// 検索タブ優待施設
export const API_SEARCH_TAG_SHOP_LIST = '/api/get_search_tag_shop_list.php'

// API-ID:
export const API_LOGOUT = '/api/sso_logout.php'

// API-ID: FAE001 エリア用お知らせデータ取得
export const API_AREA_NOTICE_LIST = '/api/get_area_notice_list.php'

// API-ID: FAE005 エリアお知らせクリックログ保存
export const API_CLICK_AREA_NOTICE_LOG = '/api/click_area_notice_log.php'

// API-ID: FAE002 汎用お知らせデータ取得
export const API_GENERAL_NOTICE_LIST = '/api/get_general_notice_list.php'

// API-ID: FAE003 バナーデータ取得
export const API_BANNER_LIST = '/api/get_banner_list.php'

// API-ID: FAE004 オススメ施設データ取得
export const API_RECOMEND_SHOP_LIST = '/api/get_recomend_shop_list.php'

// API-ID: FAJ001 市区町村データ取得
export const API_MUNICIPALITY_LIST = '/api/get_municipality_list.php'
